module.exports = __webpack_public_path__ + "static/media/pagination-arrow-blk.d633a557.svg";